const IconArrowLeftSvg = (props: any) => {
  return (
    <svg
      width="7"
      height="14"
      viewBox="0 0 7 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.82866 14C5.53666 14 5.24666 13.873 5.04866 13.627L0.22066 7.62698C-0.07734 7.25598 -0.07334 6.72598 0.23166 6.35998L5.23166 0.359984C5.58466 -0.0640163 6.21566 -0.121016 6.64066 0.231984C7.06466 0.584984 7.12166 1.21598 6.76766 1.63998L2.29266 7.01098L6.60766 12.373C6.95366 12.803 6.88566 13.433 6.45466 13.779C6.27066 13.928 6.04866 14 5.82866 14Z"
        fill="white"
      />
    </svg>
  )
}

export default IconArrowLeftSvg
